var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.82,
    height: 37.82,
    viewBox: "0 0 37.82 37.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_171009",
    "data-name": "Group 171009",
    transform: "translate(-9.59 -78.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170926",
    "data-name": "Group 170926",
    transform: "translate(6.162)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 18.91,
    cy: 18.91,
    r: 18.91,
    transform: "translate(3.428 78.852)",
    fill: "#000053"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_84ea6a54936109bb5e22b250f5dc7840",
    "data-name": "84ea6a54936109bb5e22b250f5dc7840",
    transform: "translate(12.098 87.57)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "Path_168861",
    "data-name": "Path 168861",
    d: "M19.4,7.34,16.66,4.6A2,2,0,0,0,14,4.53l-9,9a2,2,0,0,0-.57,1.21L4,18.91A1,1,0,0,0,5,20h.09l4.17-.38a2,2,0,0,0,1.21-.57l9-9a1.92,1.92,0,0,0-.07-2.71ZM16,10.68,13.32,8l1.95-2L18,8.73Z",
    transform: "translate(-1.665 -1.777)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.b9d69c66f574129b41d51d4506717f04.svg";
export { ForwardRef as ReactComponent };